/**
 * The two proposals on the customer's "Serviceförslag" step. "Trafiksäker" is
 * the work that has to be done now; "Toppskick" adds what could wait.
 */
export enum ProposalLevel {
  TRAFFIC_SAFE = "TRAFFIC_SAFE",
  TOP_CONDITION = "TOP_CONDITION",
}
